module.exports = __webpack_public_path__ + "static/media/lensfinderActive.927ccbd2.png";